import linkIcon from '@/assets/icons/link.svg'

import up from './up.svg'
import down from './down.svg'
import heat from './heat.svg'
import comment from './comment.svg'
import explore from './explore.svg'
import message from './message.svg'
import more from './more.svg'
import wallet from './wallet.svg'
import home from './home.svg'
import homeActive from './homeActive.svg'
import messageActive from './messageActive.svg'
import walletActive from './walletActive.svg'
import exploreActive from './exploreActive.svg'
import moreActive from './moreActive.svg'
import search from './search.svg'
import download from './dowload.svg'
import check from './check.svg'
import checkFollow from './checkFollow.svg'
import copy from './copy.svg'
import share from './share.svg'
import support from './support.svg'
import tickGr from './tickGreen.svg'
import close from './close-circle-svgrepo-com (1).svg'
import closeIcon from './close.svg'
import pin from './pin.svg'
import pinActive from './pinActive.svg'
import star from './stars.svg'
import person from './person.svg'
import shares from './shares.svg'
import emoji from './emoji.svg'
import emojichat from './emojichat.svg'
import bchat from './bchat.svg'
import ichat from './ichat.svg'
import imagechat from './imagechat.svg'
import sendchat from './sendchat.svg'
import arrowUp from './arrowUp.svg'
import lock from './Lock.svg'
import lockActive from './lock-active.svg'
import Unlocked from './lock-unlocked.svg'
import walletMessage from './wallet-message.svg'
import plusAdd from './plusAdd.svg'
import addImage from './addImage.svg'
import arrowUpSmall from './arrowUpSmall.svg'
import signOut from './signout.svg'
import btnMore from './btnMore.svg'
import iconEdit from './iconEdit.svg'
import edit from './edit.svg'
import iconLock from './iconLock.svg'
import iconWorld from './iconWorld.svg'
import iconPrivtie from './iconPrivtie.svg'
import iconPrivtieWhite from './iconPrivtieWhite.svg'
import iconWorldWhite from './iconWorldWhite.svg'
import iconBack from './iconBack.svg'
import heatLike from './heatLike.svg'
import messagePlusCircle from './message-plus-circle.svg'
import usersActive from './userActive.svg'
import users from './users.svg'
import user from './user.svg'
import arrowDown from './arrowDown.svg'
import event from './spaceship.svg'
import eventActive from './spaceship-active.svg'
import bookmarkIcon from './bookmark.svg'
import plusCircle from './plusCircle.svg'
import iconXRP from './iconXRP.svg'
import iconMoney from './iconMoney.svg'
import iconSHIB from './iconSHIB.svg'
import iconDownGradient from './iconDownGradient.svg'
import calendar from './calendar.svg'
import userGroup from './userGroup.svg'
import key from './key.svg'
import iconKeys from './iconKeys.svg'
import checkGreen from './checkGreen.svg'
import follower from './follower.svg'
import iconETH from './iconETH.svg'
import verifyBadge from './verify-badge.svg'
import arrowUpRight from './arrowUpRight.svg'
import arrowRight from './arrowRight.svg'
import coin from './coin.svg'
import market from './market.svg'
import btc from './btc.svg'
import analytics from './analytics.svg'
import starUnCheck from './starUnCheck.svg'
import starChecked from './starChecked.svg'
import indicatorIcon from './indicatorIcon.svg'
import refetchIcon from './refetchIcon.svg'
import crypto from './crypto.svg'
import eyes from './eyes.svg'
import iconEyes from './eyes.svg'
import ssPoint from './SS-point.svg'
import checkCircle from './check-circle.svg'
import notification from './notification.svg'
import notificationActive from './notification-active.svg'
import starKOL from './starKOL.svg'
import starKOLActive from './starKOL-active.svg'
import threeDotVertical from './iconThreeDotVertical.svg'
import setting from './setting.svg'
import icUserPlus from './user-plus.svg'
import icUserX from './user-x.svg'
import icFlag from './flag.svg'
import threeDotHorizontal from './threedot.svg'
import icSearchWhite from './search-white.svg'
import shareSquare from './shareSqare.svg'
import arrowLeft from './arrowLeft.svg'
import icFilePlus from './ic-file-plus.svg'
import icKeyWhite from './key-white.svg'
import icCloseWhite from './close-white.svg'
import icCamera from './camera-plus.svg'
import icThreeDotVerticalGray from './threedot-gray.svg'
import icSearchGray from './search-gray.svg'
import icFilter from './icFilter.svg'
import icFileCheck from './file-check.svg'
import icXSquared from './x-square.svg'
import icUsersBlue from './users-blue.svg'
import icClockRed from './clock-red.svg'
import icChevronRight from './chevron-right.svg'
import icCup from './icCup.svg'
import icLinkPrimary from './link-primary.svg'
import deposit from './deposit.svg'
import transfer from './transfer.svg'
import addImageWhite from './addImageWhite.svg'
import emojiWhite from './emojiWhite.svg'
import ssPointUncheckin from './SS-point-uncheckin.svg'
import icGift from './icGift.svg'
import icGiftActive from './icGiftActive.svg'
import helpCircle from './help-circle.svg'
import icLinkGray from './icLinkGray.svg'
import info from './info.svg'
import plusCircleWhite from './plusCircle-white.svg'
import menuBar from './menu-bar.svg'
import iconX from './iconX.svg'
import heart from './heart.svg'
import icUserPlus2 from './icon-user-plus.svg'
import icClosePurple from './close-purple.svg'
import wallet2 from './wallet-2.svg'
import icLightning from './icLightning.svg'
import icUser1 from './icon-user1.svg'
import icUsers1 from './ic_users1.svg'
import icTrashWhite from './trash-white.svg'
import icSpace from './icSpace.svg'
import icSpaceActive from './icSpaceActive.svg'
import icVerifySpace from './verify-space.svg'
import icShare from './icShare.svg'
import icBTC from './icBTC.svg'
import icLogoCircle from './ic_logo_circle.svg'
import icCopy from './icCopy.svg'
import icPlus from './icPlus.svg'
import icUserPlus3 from './icUserPlus.svg'
import calendarBlue from './calendarBlue.svg'
import icStaking from './icStaking.svg'
import icStakingActive from './icStakingActive.svg'
import icSwitch from './switch.svg'
import icTelegram2 from './icTelegram2.svg'
import icX2 from './icX2.svg'
import icInfoCircle from './icInfo-circle.svg'
import icGift2 from './icGift2.svg'
import icGiftActive2 from './icGiftActive2.svg'
import ssPointStar from './ssPointStart.svg'
import usersFill from './usersFill.svg'
import icMonkey from './icMonkey.svg'
import icWarning from './icWarningRed.svg'
import icCup1 from './icCup1.svg'
import icCup2 from './icCup2.svg'
import icCup3 from './icCup3.svg'
import ssPoint1 from './ssPoint1.svg'
import ssPoint2 from './ssPoint2.svg'
import friend1 from './friend1.svg'
import friend2 from './friend2.svg'
import friend3 from './friend3.svg'
import icXW from './icXWhite.svg'
import icTeleW from './icTeleW.svg'
import icDiscordW from './icDiscordW.svg'
import icYoutobeW from './icYoutobeW.svg'
import icTiktokW from './icTiktokW.svg'
import icFBW from './icFBW.svg'
import icXGray from './icXGray.svg'
import icTeleGray from './icTeleGray.svg'
import discordGray from './discordGray.svg'
import tiktokGray from './tiktokGray.svg'
import youtubeGray from './youtubeGray.svg'
import fbGray from './fbGray.svg'
import icPin from './pin-02.svg'

const ICONS = {
  up,
  heat,
  comment,
  down,
  explore,
  homeActive,
  message,
  more,
  wallet,
  home,
  messageActive,
  walletActive,
  exploreActive,
  moreActive,
  search,
  download,
  check,
  checkFollow,
  copy,
  share,
  support,
  arrowUp,
  tickGr,
  close,
  pin,
  pinActive,
  star,
  person,
  shares,
  emoji,
  emojichat,
  bchat,
  ichat,
  imagechat,
  sendchat,
  plusAdd,
  addImage,
  arrowUpSmall,
  signOut,
  btnMore,
  iconEdit,
  iconLock,
  iconWorld,
  iconPrivtie,
  iconPrivtieWhite,
  iconWorldWhite,
  iconBack,
  lock,
  Unlocked,
  heatLike,
  lockActive,
  walletMessage,
  messagePlusCircle,
  usersActive,
  users,
  arrowDown,
  event,
  eventActive,
  bookmarkIcon,
  plusCircle,
  iconXRP,
  iconMoney,
  iconSHIB,
  iconDownGradient,
  calendar,
  userGroup,
  linkIcon,
  key,
  iconKeys,
  checkGreen,
  follower,
  iconETH,
  arrowUpRight,
  arrowRight,
  coin,
  market,
  btc,
  analytics,
  starUnCheck,
  starChecked,
  closeIcon,
  indicatorIcon,
  refetchIcon,
  crypto,
  eyes,
  ssPoint,
  checkCircle,
  notificationActive,
  notification,
  starKOLActive,
  starKOL,
  user,
  threeDotVertical,
  setting,
  iconEyes,
  verifyBadge,
  icUserPlus,
  icUserX,
  icFlag,
  threeDotHorizontal,
  icSearchWhite,
  shareSquare,
  arrowLeft,
  icFilePlus,
  icKeyWhite,
  icCloseWhite,
  icCamera,
  icThreeDotVerticalGray,
  icSearchGray,
  icFilter,
  icFileCheck,
  icXSquared,
  icUsersBlue,
  icClockRed,
  icChevronRight,
  icCup,
  icLinkPrimary,
  deposit,
  transfer,
  addImageWhite,
  emojiWhite,
  ssPointUncheckin,
  icGift,
  icGiftActive,
  helpCircle,
  icLinkGray,
  info,
  edit,
  plusCircleWhite,
  menuBar,
  iconX,
  heart,
  icUserPlus2,
  icClosePurple,
  wallet2,
  icLightning,
  icUser1,
  icUsers1,
  icTrashWhite,
  icSpaceActive,
  icSpace,
  icVerifySpace,
  icShare,
  icBTC,
  icLogoCircle,
  icCopy,
  icPlus,
  icUserPlus3,
  calendarBlue,
  icStaking,
  icStakingActive,
  icSwitch,
  icTelegram2,
  icX2,
  icInfoCircle,
  icGift2,
  icGiftActive2,
  ssPointStar,
  usersFill,
  icMonkey,
  icWarning,
  icCup1,
  icCup2,
  icCup3,
  ssPoint1,
  ssPoint2,
  friend1,
  friend2,
  friend3,
  icXW,
  icTeleW,
  icDiscordW,
  icYoutobeW,
  icTiktokW,
  icFBW,
  icXGray,
  icTeleGray,
  discordGray,
  tiktokGray,
  youtubeGray,
  fbGray,
  icPin,
}
export default ICONS
